import { StyledBadge } from '@/components/atoms/StyledBadge/StyledBadge';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Presence } from '@/shared/types/presence';

type AgentIconProps = { agent: Presence };

export const AgentIcon = ({ agent }: AgentIconProps) => {
  return (
    <div className="inline-flex min-w-4">
      <StyledBadge anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} status={agent.status}>
        <Avatar size="xxs">
          <AvatarImage src={agent.avatar} alt={`Avatar ${agent?.name || ''}`} />
          <AvatarFallback size="xxs">{agent?.name?.[0] || '?'}</AvatarFallback>
        </Avatar>
      </StyledBadge>
    </div>
  );
};
